import { AdminAccountsTable } from '../views/index';
import { Account } from '../dtos/account';

export const ADMIN_ACCOUNTS_LIST_TABLE = (
	carrierList: Array<Account> = []
): Array<AdminAccountsTable> => {
	let results: Array<AdminAccountsTable> = [];
	if (carrierList.length > 0) {
		carrierList.map((account) => {
			let row = {} as AdminAccountsTable;
			row.accountId = account.id;
			row.accountType = account.accountType;
			row.business_name = account.businessName;
			row.dot = account.dot || '--';
			row.mc = account.mc || '--';

			if (account.subscription !== undefined && account.subscription != null) {
				row.last_payment_date = account.subscription.lastPaymentDate;
				row.next_payment_date = account.subscription.nextPaymentDate;
				row.plan = account.subscription.plan.displayName;
				row.status = account.subscription.status;
				row.subscriptionId = account.subscription.id;
				row.subscription = account.subscription;
			} else {
				row.last_payment_date = null;
				row.next_payment_date = null;
				row.plan = 'Free';
				row.status = 'INACTIVE';
				row.subscriptionId = null;
			}

			results.push(row);
		});
	}
	return results;
};
